import React from "react";
import "./NoAdvancePromo.scss";

const NoAdvancePromo = () => {
  return (
    <section className="no-advance-promo">
      <div className="no-advance-promo__container">
        <div className="no-advance-promo__box">
          <span className="no-advance-promo__eyebrow">Promoción especial</span>

          <h2 className="no-advance-promo__title">
            En canceles de cristal templado
            <span> no pedimos anticipos</span>
          </h2>

          <p className="no-advance-promo__description">
            Queremos darte mayor confianza al momento de cotizar con nosotros.
            En proyectos de canceles de cristal templado, trabajamos
            <strong> sin anticipo</strong>, para que tomes tu decisión con más
            seguridad y tranquilidad.
          </p>

          <div className="no-advance-promo__highlight">
            Aplicable únicamente en <strong>canceles de cristal templado</strong>.
          </div>
        </div>
      </div>
    </section>
  );
};

export default NoAdvancePromo;